export const API_BASE_URL = "https://edupayzservice.intimeinfo.net/api/v1";
export const API_BASE = "https://edupayzservice.intimeinfo.net";
